import { render, staticRenderFns } from "./EmojiButton.vue?vue&type=template&id=6a00ffd4&"
import script from "./EmojiButton.vue?vue&type=script&lang=ts&"
export * from "./EmojiButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports